import React, { useState, lazy } from 'react';
import { ShoppingCartIcon } from 'lucide-react';
import { ExtraBonusModal } from './ExtraBonusModal';
export function SpecialOffer() {
  const [isExtraBonusModalOpen, setIsExtraBonusModalOpen] = useState(false);
  return <>
      <section className="bg-gradient-to-b from-orange-50 to-white py-8 sm:py-12 md:py-16" data-id="element-619">
        <div className="max-w-7xl mx-auto px-4" data-id="element-620">
          <div className="text-center mb-6 sm:mb-8 md:mb-12" data-id="element-621">
            <div className="inline-block bg-red-600 text-white px-4 py-2 sm:px-6 sm:py-3 rounded-full text-base sm:text-lg md:text-xl font-bold mb-3 sm:mb-4" data-id="element-622">
              🔥 OFERTA DE LANZAMIENTO
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4 px-4" data-id="element-623">
              50 Recetas + Bonos Exclusivos
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-700 px-4" data-id="element-624">
              Todo lo que necesitas para cenas rápidas y deliciosas
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-6 sm:gap-8 mb-8 sm:mb-12" data-id="element-625">
            <div className="rounded-lg sm:rounded-xl overflow-hidden shadow-xl sm:shadow-2xl" data-id="element-626">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mpVcH5Q1tNZqAEyhJAwYAU/mujer_caminando_con_libro_50_recetas.png" alt="Mujer profesional con el libro 50 Recetas de 15 Minutos" loading="lazy" className="w-full h-full object-cover" data-id="element-627" />
            </div>
            <div className="rounded-lg sm:rounded-xl overflow-hidden shadow-xl sm:shadow-2xl" data-id="element-628">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7UZWDiPZSq8KeLP5Xu54mS/oferta_-6.png" alt="Bundle completo" loading="lazy" className="w-full h-full object-cover" data-id="element-629" />
            </div>
          </div>
          <div className="max-w-4xl mx-auto" data-id="element-630">
            <div className="bg-white rounded-xl sm:rounded-2xl shadow-xl p-4 sm:p-6 md:p-8 border-4 border-orange-200" data-id="element-631">
              <h3 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 text-center" data-id="element-632">
                Lo Que Recibes Hoy:
              </h3>
              <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8" data-id="element-633">
                <div className="flex items-start gap-3 sm:gap-4" data-id="element-634">
                  <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-sm sm:text-base" data-id="element-635">
                    ✓
                  </div>
                  <div data-id="element-636">
                    <div className="font-bold text-base sm:text-lg" data-id="element-637">
                      50 Recetas de 15 Minutos (Libro Principal)
                    </div>
                    <div className="text-sm sm:text-base text-gray-600" data-id="element-638">
                      50 recetas cronometradas, probadas y listas para usar
                    </div>
                  </div>
                </div>
                <div className="flex items-start gap-3 sm:gap-4" data-id="element-639">
                  <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-sm sm:text-base" data-id="element-640">
                    🎁
                  </div>
                  <div data-id="element-641">
                    <div className="font-bold text-base sm:text-lg" data-id="element-642">
                      BONUS 1: Loncheras que Los Niños Devoran
                    </div>
                    <div className="text-sm sm:text-base text-gray-600" data-id="element-643">
                      Valor: $37 USD - HOY GRATIS
                    </div>
                  </div>
                </div>
                <div className="flex items-start gap-3 sm:gap-4" data-id="element-644">
                  <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-sm sm:text-base" data-id="element-645">
                    🎁
                  </div>
                  <div data-id="element-646">
                    <div className="font-bold text-base sm:text-lg" data-id="element-647">
                      BONUS 2: 7 Días de Cena en 15 Minutos
                    </div>
                    <div className="text-sm sm:text-base text-gray-600" data-id="element-648">
                      Valor: $27 USD - HOY GRATIS
                    </div>
                  </div>
                </div>
                <div className="flex items-start gap-3 sm:gap-4" data-id="element-649">
                  <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-sm sm:text-base" data-id="element-650">
                    🎁
                  </div>
                  <div data-id="element-651">
                    <div className="font-bold text-base sm:text-lg" data-id="element-652">
                      BONUS 3: Kit Imprimible de Menús
                    </div>
                    <div className="text-sm sm:text-base text-gray-600" data-id="element-653">
                      Valor: $19 USD - HOY GRATIS
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ExtraBonusModal isOpen={isExtraBonusModalOpen} onClose={() => setIsExtraBonusModalOpen(false)} data-id="element-654" />
    </>;
}